import { getFirstResultLocationAndAddress } from "../../apis/search";

/** A location the user picked, resolved to coordinates. */
export type SelectedLocation = {
  /** Full label, e.g. "Shoreditch, London". */
  text: string;
  /** Short label, e.g. "Shoreditch". */
  simpleText: string;
  latitude: number;
  longitude: number;
  placeId: string | null;
};

/**
 * Legacy text-search resolve, kept as the degraded-mode fallback.
 *
 * When the Google integration is off, `resolve-suggestion-area` 404s for every
 * caller — including cities we cover, which make no Google call of their own but
 * still geocode their "City, Country" string through that same endpoint.
 *
 * `search-places` signals failure by echoing back the bias coordinates with
 * `error: true`. Returning those would relabel the map without moving it, so the
 * flag is read as "no result", not as a location.
 */
export async function resolveAreaByText(
  text: string,
  latitude?: number,
  longitude?: number,
): Promise<SelectedLocation | null> {
  const result = await getFirstResultLocationAndAddress(
    text,
    latitude ?? 0,
    longitude ?? 0,
  );
  if (!result || result.error || !result.lat || !result.lng) return null;

  return {
    text: result.address || text,
    simpleText: result.simpleAddress || text,
    latitude: result.lat,
    longitude: result.lng,
    placeId: null,
  };
}
